// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeDGIEnsjT\\+qrxvi5oqRBA\\=\\= {\n  width: 50px;\n}\n", "",{"version":3,"sources":["webpack://./src/content/styles/LessonPointsField.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":[".numberField {\n  width: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numberField": "FeDGIEnsjT+qrxvi5oqRBA=="
};
export default ___CSS_LOADER_EXPORT___;
